// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Shell - Shared layout for Landing and Chat */
.app-shell {
  padding: 16px;
  height: 100vh;
  background: var(--bg-white);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Shared Navigation Bar - Two Row Layout */
.app-navbar {
  display: flex;
  flex-direction: column;
  background: var(--bg-white);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* Navbar Rows */
.nav-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5%;
  width: 100%;
}

.nav-row-top {
  padding-top: 1rem;
  padding-bottom: 0.75rem;
}

.nav-row-bottom {
  padding-top: 0.5rem;
  padding-bottom: 0.75rem;
  border-top: 1px solid var(--border-color);
}

/* Row 1: Logo (left) | Actions (right) */
.nav-left-top {
  display: flex;
  align-items: center;
}

.nav-right-top {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-logo {
  height: 55px;
  object-fit: contain;
}

/* Row 2: Back to Explore (left) | Agent Active (right) */
.nav-left-bottom {
  display: flex;
  align-items: center;
  flex: 1 1;
}

.nav-right-bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1;
}

.back-link {
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.2s;
  padding: 0.5rem 0;
  font-family: inherit;
}

.back-link:hover {
  color: var(--dbs-red);
}

.back-link i {
  font-size: 0.9rem;
}

.agent-status {
  font-size: 0.8rem;
  font-weight: 700;
  color: #4caf50;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #4caf50;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-action-btn {
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  padding: 0;
}

.nav-action-btn:hover {
  background: var(--bg-light);
  border-color: var(--dbs-red);
  color: var(--dbs-red);
}

.nav-action-btn.active {
  background: var(--dbs-red);
  border-color: var(--dbs-red);
  color: white;
}

.nav-action-btn.active:hover {
  background: var(--dbs-red-dark);
}

.nav-avatar {
  width: 35px;
  height: 35px;
  background: var(--dbs-red);
  color: var(--bg-white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
}

/* Centered Content Container */
.app-main {
  flex: 1 1;
  max-width: 1800px;
  margin: 0 auto;
  width: 100%;
  padding: 0 0%;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .nav-row {
    padding: 0 4%;
  }
  
  .nav-row-top {
    padding-top: 0.75rem;
    padding-bottom: 0.5rem;
  }
  
  .nav-row-bottom {
    padding-top: 0.4rem;
    padding-bottom: 0.5rem;
  }
  
  .nav-logo {
    height: 40px;
  }
  
  .back-link {
    font-size: 0.9rem;
  }
  
  .back-link span {
    display: none; /* Hide text on mobile, show only icon */
  }
  
  .agent-status {
    font-size: 0.7rem;
  }
  
  .nav-action-btn {
    width: 32px;
    height: 32px;
  }
  
  .nav-avatar {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppShell.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa,EAAE,wCAAwC;EACzD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* App Shell - Shared layout for Landing and Chat */\n.app-shell {\n  padding: 16px;\n  height: 100vh;\n  background: var(--bg-white);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Shared Navigation Bar - Two Row Layout */\n.app-navbar {\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-white);\n  border-bottom: 1px solid var(--border-color);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n/* Navbar Rows */\n.nav-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 5%;\n  width: 100%;\n}\n\n.nav-row-top {\n  padding-top: 1rem;\n  padding-bottom: 0.75rem;\n}\n\n.nav-row-bottom {\n  padding-top: 0.5rem;\n  padding-bottom: 0.75rem;\n  border-top: 1px solid var(--border-color);\n}\n\n/* Row 1: Logo (left) | Actions (right) */\n.nav-left-top {\n  display: flex;\n  align-items: center;\n}\n\n.nav-right-top {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.nav-logo {\n  height: 55px;\n  object-fit: contain;\n}\n\n/* Row 2: Back to Explore (left) | Agent Active (right) */\n.nav-left-bottom {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.nav-right-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 1;\n}\n\n.back-link {\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: color 0.2s;\n  padding: 0.5rem 0;\n  font-family: inherit;\n}\n\n.back-link:hover {\n  color: var(--dbs-red);\n}\n\n.back-link i {\n  font-size: 0.9rem;\n}\n\n.agent-status {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #4caf50;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  background: #4caf50;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.nav-action-btn {\n  background: none;\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.nav-action-btn:hover {\n  background: var(--bg-light);\n  border-color: var(--dbs-red);\n  color: var(--dbs-red);\n}\n\n.nav-action-btn.active {\n  background: var(--dbs-red);\n  border-color: var(--dbs-red);\n  color: white;\n}\n\n.nav-action-btn.active:hover {\n  background: var(--dbs-red-dark);\n}\n\n.nav-avatar {\n  width: 35px;\n  height: 35px;\n  background: var(--dbs-red);\n  color: var(--bg-white);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* Centered Content Container */\n.app-main {\n  flex: 1;\n  max-width: 1800px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 0%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .nav-row {\n    padding: 0 4%;\n  }\n  \n  .nav-row-top {\n    padding-top: 0.75rem;\n    padding-bottom: 0.5rem;\n  }\n  \n  .nav-row-bottom {\n    padding-top: 0.4rem;\n    padding-bottom: 0.5rem;\n  }\n  \n  .nav-logo {\n    height: 40px;\n  }\n  \n  .back-link {\n    font-size: 0.9rem;\n  }\n  \n  .back-link span {\n    display: none; /* Hide text on mobile, show only icon */\n  }\n  \n  .agent-status {\n    font-size: 0.7rem;\n  }\n  \n  .nav-action-btn {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .nav-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
